import React from 'react';
import { connect } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import TooltipMessage from '../../../helpers/tooltipMessage.js';
import { ValidMe } from '../../../../businessLogic/validation.js';
import { updateWebsiteButtonForm } from '../../../../actions/waitingArea';
import { clone } from '../../../../reducers/helper.js';
import { useMediaQuery } from 'react-responsive';
import { oldBreakpoints } from '../../../../mediaSetting';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export function CenterPanelWebsiteButton(props) {
  const lessThanExtraSmall = useMediaQuery({
    query: `(max-width: ${oldBreakpoints.extraSmall}px)`,
  });
  return <CenterPanelWebsiteButtonClass {...props} lessThanExtraSmall={lessThanExtraSmall} />;
}

class CenterPanelWebsiteButtonClass extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isMobileSize: false,
    };
  }
  UNSAFE_componentWillReceiveProps(props) {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA

    this.hideOrShowMobileVersion(props.lessThanExtraSmall);
  }

  componentDidMount() {
    var clipboard = new window.Clipboard('.copy-to-clipboard-button');
    clipboard.on('success', function (e) {
      console.info('Action:', e.action);
      console.info('Text:', e.text);
      console.info('Trigger:', e.trigger);
      e.clearSelection();
    });
  }

  hideOrShowMobileVersion(lessThanExtraSmall) {
    //if the popup not visible no need to change state.
    //If the popup is invisible but cally by componentwill mount, then adjust the state
    //TODO: we should move it to some parent component or at  reducer.
    if (lessThanExtraSmall) {
      this.setState({ isMobileSize: true });
    } else {
      this.setState({ isMobileSize: false });
    }
  }

  mainButtonImageChanged = (value) => {
    var websiteButton = clone(this.props.websiteButtonDetails);
    websiteButton.mainImageUrl = value;
    this.props.dispatch(updateWebsiteButtonForm(websiteButton));
  };

  hoverButtonImageChanged = (value) => {
    var websiteButton = clone(this.props.websiteButtonDetails);
    websiteButton.hoverImageUrl = value;
    this.props.dispatch(updateWebsiteButtonForm(websiteButton));
  };

  suspendButtonImageChanged = (value) => {
    var websiteButton = clone(this.props.websiteButtonDetails);
    websiteButton.suspendedImageUrl = value;
    this.props.dispatch(updateWebsiteButtonForm(websiteButton));
  };
  closedButtonImageChanged = (value) => {
    var websiteButton = clone(this.props.websiteButtonDetails);
    websiteButton.closedImageUrl = value;
    this.props.dispatch(updateWebsiteButtonForm(websiteButton));
  };
  buttonHostUrlChanged = (value) => {
    var websiteButton = clone(this.props.websiteButtonDetails);
    websiteButton.buttonHostUrl = value;
    this.props.dispatch(updateWebsiteButtonForm(websiteButton));
  };

  render() {
    let textSizeHeaderLabel = this.state.isMobileSize
      ? ' mrtnull pdtxxs bold color-white align-top-vertical text-size-m'
      : ' span-like mrlm mrtnull pdtxs align-top-vertical bold text-size-mml';
    let marginLeftField = this.state.isMobileSize ? '' : ' mrlxl';
    let marginLeftHeader = this.state.isMobileSize ? '' : ' mrlxxs mrbnull';
    // let ClassStep1Desc =

    return (
      <div className="ui form">
        <span className="color-white">{this.state.isMobileSize}</span>
        <div className={'mrbs  pdbnull' + marginLeftHeader}>
          <span
            data-show={!this.state.isMobileSize}
            className="span-like mrtnull pdtnull mrbnull pdbnull  bold text-size-xxl"
          >
            {APP.LANGUAGE.WaitingAreaWebsiteButton.Step1Header}
          </span>
          <span className={textSizeHeaderLabel}>
            {' '}
            {this.state.isMobileSize
              ? APP.LANGUAGE.WaitingAreaWebsiteButton.Step1Header +
                '. ' +
                APP.LANGUAGE.WaitingAreaWebsiteButton.Step1Label
              : APP.LANGUAGE.WaitingAreaWebsiteButton.Step1Label}
          </span>
        </div>

        <div className={'mrtnull pdtnull mrbs' + marginLeftField}>
          <span className="span-like  mrtnull pdtnull text-size-ms color-info">
            {htmlToReactParser.parse(xss(APP.LANGUAGE.WaitingAreaWebsiteButton.Step1Description))}
          </span>
        </div>

        <div className={'mrtnull pdtnull  mrbs ' + marginLeftField}>
          <TooltipMessage
            text={APP.LANGUAGE.CopySuccess}
            position="top center"
            classes="wa-websiteButtonWidth  ui span-like   icon  color-white"
          >
            <button
              type="button"
              data-clipboard-text={
                this.props.websiteButtonDetails ? this.props.websiteButtonDetails.websiteButtonScript : 'copied'
              }
              className="copy-to-clipboard-button left-text ui dropdown labeled icon  button color-info color-white max-width desktop-settings no-bold"
            >
              <i className=" icon copy LinkToClipboard note outline text-size-m" />
              {APP.LANGUAGE.WaitingAreaWebsiteButton.CopyLinkToClipboard}
            </button>
          </TooltipMessage>
        </div>

        <div className={' mrtl ' + marginLeftHeader}>
          <span
            data-show={!this.state.isMobileSize}
            className="span-like mrtnull pdtnull mrbnull pdbnull  bold text-size-xxl"
          >
            {APP.LANGUAGE.WaitingAreaWebsiteButton.Step2Header}
          </span>
          <span className={textSizeHeaderLabel}>
            {' '}
            {this.state.isMobileSize
              ? APP.LANGUAGE.WaitingAreaWebsiteButton.Step2Header +
                '. ' +
                APP.LANGUAGE.WaitingAreaWebsiteButton.Step2Label
              : APP.LANGUAGE.WaitingAreaWebsiteButton.Step2Label}
          </span>
        </div>
        <div className={'mrtl ' + marginLeftField}>
          <ValidMe
            validmefor="urlOptional"
            validmemessage={APP.LANGUAGE.Errors.OrgWebsiteButtonHostingHttpsUrlError}
            group="createWebsiteButtonDetails"
          >
            <Txt
              tabIndex="1"
              value={this.props.websiteButtonDetails ? this.props.websiteButtonDetails.buttonHostUrl : ''}
              titlePlaceholder={APP.LANGUAGE.WaitingAreaWebsiteButton.ButtonHostingLabel}
              placeholder={APP.LANGUAGE.WaitingAreaWebsiteButton.ButtonHostingLabel}
              onChange={this.buttonHostUrlChanged}
            />
          </ValidMe>
        </div>

        <div className={'mrbs mrtl   pdbnull' + marginLeftHeader}>
          <span
            data-show={!this.state.isMobileSize}
            className="span-like mrtnull pdtnull mrbnull pdbnull  bold text-size-xxl"
          >
            {APP.LANGUAGE.WaitingAreaWebsiteButton.Step3Header}
          </span>
          <span className={textSizeHeaderLabel}>
            {' '}
            {this.state.isMobileSize
              ? APP.LANGUAGE.WaitingAreaWebsiteButton.Step3Header +
                '. ' +
                APP.LANGUAGE.WaitingAreaWebsiteButton.Step3Label
              : APP.LANGUAGE.WaitingAreaWebsiteButton.Step3Label}
          </span>
        </div>
        <div className={'mrtnull pdtnull mrbs' + marginLeftField}>
          <span className="span-like mrtnull pdtnull text-size-ms color-info">
            {' '}
            {APP.LANGUAGE.WaitingAreaWebsiteButton.Step3Description}{' '}
          </span>
        </div>
        <div className={'mrtl' + marginLeftField}>
          <ValidMe
            validmefor="urlOptional"
            validmemessage={APP.LANGUAGE.Errors.MainImageWAHttpsUrlError}
            group="createWebsiteButtonDetails"
          >
            <Txt
              tabIndex="2"
              value={this.props.websiteButtonDetails ? this.props.websiteButtonDetails.mainImageUrl : ''}
              placeholder={APP.LANGUAGE.WaitingAreaWebsiteButton.MainButtonImagePlaceHolder}
              noTitle
              titlePlaceholder={APP.LANGUAGE.WaitingAreaWebsiteButton.MainButtonImageLabel}
              onChange={this.mainButtonImageChanged}
            />
          </ValidMe>
        </div>
        <div className={'mrtl' + marginLeftField}>
          <ValidMe
            validmefor="urlOptional"
            validmemessage={APP.LANGUAGE.Errors.HoverStateWAHttpsUrlError}
            group="createWebsiteButtonDetails"
          >
            <Txt
              tabIndex="3"
              value={this.props.websiteButtonDetails ? this.props.websiteButtonDetails.hoverImageUrl : ''}
              placeholder={APP.LANGUAGE.WaitingAreaWebsiteButton.HoverButtonImagePlaceHolder}
              noTitle
              titlePlaceholder={APP.LANGUAGE.WaitingAreaWebsiteButton.HoverButtonImageLabel}
              onChange={this.hoverButtonImageChanged}
            />
          </ValidMe>
        </div>
        <div className={'mrtl' + marginLeftField}>
          <ValidMe
            validmefor="urlOptional"
            validmemessage={APP.LANGUAGE.Errors.SuspendedImageWAHttpsUrlError}
            group="createWebsiteButtonDetails"
          >
            <Txt
              tabIndex="4"
              value={this.props.websiteButtonDetails ? this.props.websiteButtonDetails.suspendedImageUrl : ''}
              placeholder={APP.LANGUAGE.WaitingAreaWebsiteButton.SuspendedButtonImagePlaceHolder}
              noTitle
              titlePlaceholder={APP.LANGUAGE.WaitingAreaWebsiteButton.SuspendedButtonImageLabel}
              onChange={this.suspendButtonImageChanged}
            />
          </ValidMe>
        </div>
        <div className={'mrtl' + marginLeftField}>
          <ValidMe
            validmefor="urlOptional"
            validmemessage={APP.LANGUAGE.Errors.ClosedImageWAHttpsUrlError}
            group="createWebsiteButtonDetails"
          >
            <Txt
              tabIndex="5"
              value={this.props.websiteButtonDetails ? this.props.websiteButtonDetails.closedImageUrl : ''}
              placeholder={APP.LANGUAGE.WaitingAreaWebsiteButton.ClosedButtonImagePlaceHolder}
              noTitle
              titlePlaceholder={APP.LANGUAGE.WaitingAreaWebsiteButton.ClosedButtonImageLabel}
              onChange={this.closedButtonImageChanged}
            />
          </ValidMe>
        </div>
      </div>
    );
  }
}

let reduxGetterSetter = connect()(CenterPanelWebsiteButton); //CONNECT IS A REACT HELPER FUNCTION
export default reduxGetterSetter;
